import { css } from "@emotion/core"
import { FC } from "react"
import { Box, Center, Cluster, Frame, Grid, Stack, Switcher, Text } from "../common"
import { NextIcon } from "../common/icons/NextIcon"

export const CityProducts: FC<any> = props => (
  <Box
    style={{ margin: "-var(--s2)" }}
    css={css`
      padding-top: var(--s4) !important;
      padding-bottom: var(--s4) !important;
      background-image: url("https://res.cloudinary.com/dhoiqmk4x/image/upload/c_scale,f_auto,w_1400/v1597800020/products-background_p1q9pa.png");
    `}
  >
    <Center gutters="var(--s2)" maxWidth="var(--max-width)">
      <Stack space="var(--s3)">


        <Grid gap="var(--s0)" min="500px">
          <Box>
            <Switcher max={2} threshold="0px" space="var(--s0)">
              {/* <NextIcon /> */}

              <Stack space="var(--s0)" style={{ flexGrow: 15 }}>
                <Text
                  style={{
                    textTransform: "uppercase",
                    color: "white",
                    marginBottom: 30,
                  }}
                  variant="h2"
                  css={css`
            @media screen and (max-width: 600px) {
              text-align: center;
            }
          `}
                >
                  EASY STEPS
                </Text>
                {/* <Text variant="h3">{"item.title"}</Text> */}
                <EasySteps data={props.easy_steps} />
                <ul
                  style={{ listStyleType: "none" }}
                  css={css`
                          p {
                            margin-bottom: var(--s-2);
                          }
                        `}
                >
                  <li>
                    <Text
                      variant="h4"
                      color="light"
                      style={{ fontFamily: "var(--body-font-family)" }}
                    >

                    </Text>
                  </li>
                </ul>
              </Stack>
            </Switcher>
          </Box>


          <Box>
            <Switcher max={2} threshold="0px" space="var(--s0)">
              <Stack space="var(--s0)" style={{ flexGrow: 15 }}>
                <Frame numerator={5} denominator={6}>
                  <img
                    src="https://res.cloudinary.com/dhoiqmk4x/image/upload/v1630949751/ZinCash-Urgent-Personal-Loan-App-Image-by-Zavron_ovkpsr.png"
                    alt=""
                    style={{ height: "auto" }}
                  />
                </Frame>
              </Stack>
            </Switcher>
          </Box>


        </Grid>

      </Stack>

    </Center>
  </Box>
)


const EasySteps: FC<{ data: Array<{ title: string; content: string[] }> }> = props => {

  return (
    <Stack space="var(--s1)">
      {props.data.map(item => (
        <Cluster space="var(--s0)" align="flex-start">

          <Text
            style={{
              color: "var(--secondary-color)",
              fontFamily: "var(--body-font-family)",
            }}
            variant="h2"
          >
            <NextIcon />
          </Text>
          <Stack space="var(--s0)" style={{ maxWidth: '80%' }}>
            <Text
              variant="h3"
              style={{ fontFamily: "var(--heading-font-regular)", color: "white", }}
            >
              {item.title}
            </Text>
            <Text style={{ color: "#98a5c9" }} variant="p">
              {item.content}
            </Text>
          </Stack>
        </Cluster>
      ))}
      <Text
        variant="h4"
        style={{ fontWeight: "normal", fontFamily: "var(--body-font-family)" }}>
      </Text>
    </Stack>
  )
}